import { useLang } from "../contexts/LanguageContext";
import { ArrowDownRight } from "lucide-react";
import { CountUp } from "./CountUp";

export function Hero({ onCtaPrimary, onCtaSecondary }) {
  const { t } = useLang();
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden text-primary-foreground"
    >
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1568347877321-f8935c7dc5a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxjYXJnbyUyMHNoaXAlMjBvY2VhbiUyMHN1bnNldHxlbnwwfHx8fDE3ODE0MzIxNDd8MA&ixlib=rb-4.1.0&q=85"
          alt="MSC cargo ship sailing at sunset"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1A120B]/85 via-[#1A120B]/60 to-[#1A120B]/30" />
      </div>

      <div className="relative z-10 px-6 md:px-12 lg:px-20 pt-40 pb-16 min-h-[100svh] flex flex-col justify-between">
        <div className="max-w-5xl space-y-8">
          <p
            data-testid="hero-eyebrow"
            className="tracking-eyebrow uppercase text-xs text-secondary fade-up"
          >
            {t.hero.eyebrow}
          </p>
          <h1
            data-testid="hero-title"
            className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-[5.5rem] leading-[1.02] text-balance fade-up-delay-1"
          >
            {t.hero.title}
          </h1>
          <p
            data-testid="hero-subtitle"
            className="text-base sm:text-lg max-w-2xl text-primary-foreground/85 leading-relaxed fade-up-delay-2"
          >
            {t.hero.subtitle}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 pt-4 fade-up-delay-3">
            <button
              data-testid="hero-cta-primary"
              onClick={onCtaPrimary}
              className="bg-secondary text-secondary-foreground px-8 py-4 text-sm tracking-wide hover:bg-[#C08B46] transition-colors inline-flex items-center gap-2"
            >
              {t.hero.cta_primary}
              <ArrowDownRight strokeWidth={1.6} size={18} />
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={onCtaSecondary}
              className="border border-primary-foreground/60 text-primary-foreground px-8 py-4 text-sm tracking-wide hover:bg-primary-foreground hover:text-primary transition-colors"
            >
              {t.hero.cta_secondary}
            </button>
          </div>
        </div>

        <div
          data-testid="hero-stats"
          className="grid grid-cols-3 gap-4 md:gap-12 border-t border-primary-foreground/20 pt-8 mt-12 max-w-3xl"
        >
          {[
            { v: t.hero.stat1_value, l: t.hero.stat1_label },
            { v: t.hero.stat2_value, l: t.hero.stat2_label },
            { v: t.hero.stat3_value, l: t.hero.stat3_label },
          ].map((s, i) => (
            <div key={i} className="space-y-2">
              <CountUp
                value={s.v}
                className="block font-display text-4xl md:text-5xl text-secondary"
              />
              <p className="text-xs md:text-sm tracking-wide uppercase text-primary-foreground/70">
                {s.l}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
